/**
* This file originated from:
* File: app/views/bonz/forgotPassword.view.html
* In commit: 78c68c2a59ae1b30aac5b88d7b90659f4aca5fb0
* For ticket: GRINS-1511
*/


/* from: javascripts/bundles/bonz/style-guide.js */
import '@fd-assets/micromodal/microModal.js';


/* from: javascripts/bundles/transpiled/shared/forgotPassword.js */
import '@grins/fd-modules/shared/bonz/forgotPassword.app';

